/* This file was generated automatically. Do not edit manually. */

export enum ExportStateEnum {
    Pending = 0,
    Processing = 1,
    Success = 2,
    Failed = 3,
    TimedOut = 4,
}
